import { ChangeDetectorRef, Component, inject, Input, OnInit } from '@angular/core';
import { formatNumber } from '@app/helpers/webform';
import { KeyValue } from '@app/services/webform.service';
import { add, format, lastDayOfMonth, parse } from 'date-fns';

@Component({
  standalone: false,
  selector: 'webform-calc-bike',
  templateUrl: './bike.component.html',
  styleUrls: ['./bike.component.scss'],
})
export class BikeComponent implements OnInit {
  @Input() result!: KeyValue;
  @Input() formId!: string;
  @Input() formData!: KeyValue;
  formatNumber: Function = formatNumber;

  readonly #cdr = inject(ChangeDetectorRef);

  ngOnInit(): void {
    setTimeout(() => {
      this.#cdr.detectChanges();
    }, 300);
  }

  get today(): string {
    return format(new Date(), 'dd.MM.yyyy');
  }
  get contractStart(): string {
    const date = this.formData[`${this.formId}--ins_start_date`];
    if (date) return date;
    return '';
  }

  public get contractEnd(): string {
    let start: any =
      this.formData[`${this.formId}--ins_start`] === 'today'
        ? this.today
        : this.contractStart;
    if (!start) return '';
    start = parse(start, 'dd.MM.yyyy', new Date());
    return format(
      lastDayOfMonth(
        add(start, {
          years: 10,
        })
      ),
      'dd.MM.yyyy'
    );
  }
}
